import { render, staticRenderFns } from "./feedback-rating.vue?vue&type=template&id=8c352952"
import script from "./feedback-rating.vue?vue&type=script&lang=js"
export * from "./feedback-rating.vue?vue&type=script&lang=js"
import style0 from "./feedback-rating.vue?vue&type=style&index=0&id=8c352952&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports